// extracted by mini-css-extract-plugin
export default {"tabs":"AdOverviewPage_tabs__1KW+S","tabPanel":"AdOverviewPage_tabPanel__+lK9g"};